import { lazy, Suspense, ComponentType } from 'react';
import PageLoader from '../components/PageLoader';
import styles from './MicroFrontendLoader.module.css';

interface MicroFrontendLoaderProps {
  serviceType: string;
}

// Micro-frontend registry
// In production, these would be loaded from remote URLs using Module Federation
const microFrontendRegistry: Record<string, () => Promise<{ default: ComponentType }>> = {
  'seo-tools': () => import('./services/SeoTools'),
  'network-tools': () => import('./services/NetworkTools'),
  'dev-tools': () => import('./services/DevTools'),
};

function MicroFrontendLoader({ serviceType }: MicroFrontendLoaderProps) {
  const loader = microFrontendRegistry[serviceType];

  if (!loader) {
    return (
      <div className={styles.notFound}>
        <p>Service module not available</p>
      </div>
    );
  }

  const LazyComponent = lazy(loader);

  return (
    <div className={styles.container}>
      <Suspense fallback={<PageLoader />}>
        <LazyComponent />
      </Suspense>
    </div>
  );
}

export default MicroFrontendLoader;
